/**
 * While set (during /admin/login submit), the global SIGNED_OUT handler must not
 * hard-navigate to /login — e.g. after rejecting a non-admin session.
 */
export const ADMIN_LOGIN_FLOW_SESSION_KEY = "admin_login_flow";
